import {
  addressTypeApi,
  applicationStatusApi,
  applicationTypeApi,
  countryApi,
  courseNumberApi,
  decisionApi,
  educationDocTypeApi,
  educationFormApi,
  expirationReasonApi,
  genderApi,
  groupNumberApi,
  helpTypeApi,
  identityCardDocTypeApi,
  messageFormatApi,
  messageStatusApi,
  messageTypeApi,
  organizationApi,
  paidFormApi,
  semesterApi,
  specialityApi,
  yearApi,
  submissionSessionApi,
  usersApi
} from '@/api'

export default {
  namespaced: true,

  state: {
    dictionaries: {
      addressType: [],
      applicationStatus: [],
      applicationType: [],
      applicationTypeActual: [],
      country: [],
      courseNumber: [],
      decision: [],
      educationDocType: [],
      educationForm: [],
      expirationReason: [],
      gender: [],
      groupNumber: [],
      helpType: [],
      identityCardDocType: [],
      messageFormat: [],
      messageStatus: [],
      messageType: [],
      organization: [],
      paidForm: [],
      semester: [],
      speciality: [],
      year: [],
      submissionSession: [],
      curator: [],
    }
  },

  getters: {
    dictionaries: state => state.dictionaries,
    isActualSubmissionSession: state => state.dictionaries.submissionSession.filter(item => item.isActual)
  },

  mutations: {
    setAddressType(state, payload) {
      state.dictionaries.addressType = payload
    },
    setApplicationStatus(state, payload) {
      state.dictionaries.applicationStatus = payload
    },
    setApplicationType(state, payload) {
      state.dictionaries.applicationType = payload
    },
    setApplicationTypeActual(state, payload) {
      state.dictionaries.applicationTypeActual = payload
    },
    setCountry(state, payload) {
      state.dictionaries.country = payload?.filter(el => el)
    },
    setCourseNumber(state, payload) {
      state.dictionaries.courseNumber = payload
    },
    setDecision(state, payload) {
      state.dictionaries.decision = payload
    },
    setEducationDocType(state, payload) {
      state.dictionaries.educationDocType = payload
    },
    setEducationForm(state, payload) {
      state.dictionaries.educationForm = payload
    },
    setExpirationReason(state, payload) {
      state.dictionaries.expirationReason = payload
    },
    setGender(state, payload) {
      state.dictionaries.gender = payload
    },
    setGroupNumber(state, payload) {
      state.dictionaries.groupNumber = payload
    },
    setHelpType(state, payload) {
      state.dictionaries.helpType = payload
    },
    setIdentityCardDocType(state, payload) {
      state.dictionaries.identityCardDocType = payload
    },
    setMessageFormat(state, payload) {
      state.dictionaries.messageFormat = payload
    },
    setMessageStatus(state, payload) {
      state.dictionaries.messageStatus = payload
    },
    setMessageType(state, payload) {
      state.dictionaries.messageType = payload
    },
    setOrganization(state, payload) {
      state.dictionaries.organization = payload
    },
    setPaidForm(state, payload) {
      state.dictionaries.paidForm = payload
    },
    setSemester(state, payload) {
      state.dictionaries.semester = payload
    },
    setSpeciality(state, payload) {
      state.dictionaries.speciality = payload
    },
    setYear(state, payload) {
      state.dictionaries.year = payload
    },
    setSubmissionSession(state, payload) {
      state.dictionaries.submissionSession = payload
    },
    setCurator(state, payload) {
      state.dictionaries.curator = payload
    }
  },

  actions: {
    async FIND_ALL_CURATORS({commit}) {
      try {
        const data = await usersApi.findAllCurators()
        commit('setCurator', data)
      } catch (e) {
        console.log(e)
        return Promise.reject(e)
      }
    },

    async GET_CATALOG({ commit }) {
      try {
        let [
          addressType,
          applicationStatus,
          applicationType,
          applicationTypeActual,
          country,
          courseNumber,
          decision,
          educationDocType,
          educationForm,
          expirationReason,
          gender,
          groupNumber,
          helpType,
          identityCardDocType,
          messageFormat,
          messageStatus,
          messageType,
          organization,
          paidForm,
          semester,
          speciality,
          year,
          submissionSession
        ] = await Promise.all([
          addressTypeApi.getCatalog(),
          applicationStatusApi.getCatalog(),
          applicationTypeApi.getCatalog(),
          applicationTypeApi.findActual(),
          countryApi.getCatalog(),
          courseNumberApi.getCatalog(),
          decisionApi.getCatalog(),
          educationDocTypeApi.getCatalog(),
          educationFormApi.getCatalog(),
          expirationReasonApi.getCatalog(),
          genderApi.getCatalog(),
          groupNumberApi.getCatalog(),
          helpTypeApi.getCatalog(),
          identityCardDocTypeApi.getCatalog(),
          messageFormatApi.getCatalog(),
          messageStatusApi.getCatalog(),
          messageTypeApi.getCatalog(),
          organizationApi.getCatalog(),
          paidFormApi.getCatalog(),
          semesterApi.getCatalog(),
          specialityApi.getCatalog(),
          yearApi.getCatalog(),
          submissionSessionApi.getCatalog()
        ])

        country = country.sort((a,b) => {
          if (a.name > b.name) return 1
          else if (a.name < b.name) return -1
          else return 0
        })
        const RF = country.find(el => el.code === 'РФ')
        country.unshift(RF)

        commit('setAddressType', addressType)
        commit('setApplicationStatus', applicationStatus)
        commit('setApplicationType', applicationType)
        commit('setApplicationTypeActual', applicationTypeActual)
        commit('setCountry', country)
        commit('setCourseNumber', courseNumber)
        commit('setDecision', decision)
        commit('setEducationDocType', educationDocType)
        commit('setEducationForm', educationForm)
        commit('setExpirationReason', expirationReason)
        commit('setGender', gender)
        commit('setGroupNumber', groupNumber)
        commit('setHelpType', helpType)
        commit('setIdentityCardDocType', identityCardDocType)
        commit('setMessageFormat', messageFormat)
        commit('setMessageStatus', messageStatus)
        commit('setMessageType', messageType)
        commit('setOrganization', organization)
        commit('setPaidForm', paidForm)
        commit('setSemester', semester)
        commit('setSpeciality', speciality)
        commit('setYear', year)
        commit('setSubmissionSession', submissionSession)
      }
      catch (e) {
        console.log(e)
        return Promise.reject(e)
      }
    },
  }
}
